import { render, staticRenderFns } from "./AlreadyAnswer.vue?vue&type=template&id=346c5c34&"
import script from "./AlreadyAnswer.vue?vue&type=script&lang=js&"
export * from "./AlreadyAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports